<template>
<div class="newsList">
    <div class="top-box">
        <div class="bg" :style="{backgroundImage: `url(${image})`}">
            <navTop></navTop>
            <div class="banner-box">
                新闻动态
            </div>
        </div>
    </div>
    <div class="newsDetails-box">
        <div class="newsDetails-content">
            <div class="left-date">
                <div class="date">{{date}}</div>
                <div class="year">{{year}}</div>
            </div>
            <div class="center-main">
                <div class="content">
                    <div class="center-title-box">
                        <div class="title">认真学习领会习近平生态文明思想，持续提升新区生态文明建设水平！</div>
                        <div class="info"><span>要闻</span>&nbsp;<span>文章来源：天府发布</span>&nbsp;<span>文章标签：综合</span>&nbsp;<span>访问量:21次</span></div>
                    </div>
                    <img src="../assets/images/cross-icon.png" alt="" width="100%">
                    <div class="text mgt50">8月28日，四川天府新区党工委委员（扩大）会议暨新区迎接第二轮中央生态环境保护督察工作领导小组第二次会议召开，集中学习习近平生态文明思想及习近平总书记关于生态文明建设重要论述精神，传达学习省市关于第二轮中央生态环境保护督察相关会议精神，四川天府新区党工委书记刘任远主持会议并讲话。他强调，要坚定不移地以习近平生态文明思想及习近平总书记关于生态文明建设重要论述精神为指引，坚决扛起公园城市“首提地”的政治责任和时代使命，坚持走生态优先、绿色发展之路，持续提升新区生态文明建设水平，加快打造宣传习近平生态文明思想的重要窗口、世界城市可持续发展的中国方案、彰显中国特色社会主义制度优越性的未来城市样板。</div>
                    <img src="../assets/images/cross-icon.png" alt="" width="100%" class="mgt50">
                    <div class="text mgt50"> 会议指出，党的十八大以来，以习近平同志为核心的党中央，始终把生态文明建设摆在全局工作的突出位置，将生态文明建设作为“五位一体”总体布局的重要内容，开展了一系列根本性、开创性、长远性工作，采取了一系列最严厉的生态环境保护和治理举措。建立实施中央生态环境保护督察制度，是习近平总书记亲自倡导并推动的一项重大改革举措，事关生态文明建设大局，事关中华民族永续发展大计，事关提升人民美好生活感受大事，充分彰显了党中央加强生态文明建设和生态环境保护的坚强意志和坚定决心。</div>
                </div>
                <div class="return-text" @click="returnPage">返回列表</div>
            </div>
            <div class="right-list">
                <div class="top-title">推荐新闻</div>
                <div class="imgs">
                    <img src="../assets/images/cross-icon.png" alt="" width="100%">
                    <div class="show-text">全力打造立足四川、辐射西部、影响全国、
                        面向世界的一流法治创新和法律服务高地！</div>
                </div>
                <div class="list-right-box">
                    <div class="list-right-child" v-for="(item,index) in newsList" :key="index">
                        <img :src="item.icon" alt="" width="112px">
                        <div class="child-right-text">
                            <div>{{item.title}}</div>
                            <div class="mgt10">{{item.year}}.{{item.date}}</div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

    </div>
    <div class="footer-box">
        <div class="footer-top">
            <div class="child-info">
                客服热线：028-8335-5593<br>
                （工作日09:00~18:00）
            </div>
            <div class="child-info">
                商务合作：service@scitcs.com<br>
                （工作时段2小时内回复）
            </div>
            <div class="child-info">
                公司地址：成都市高新区天泰路<br>112号四川投资大厦15楼北
            </div>
        </div>
        <div class="footer-bottom">
            <div class="bottom-left">
                <div class="com">四川省外综云服科技有限公司</div>
                <div class="addr"><span>Copyright©2019 &nbsp;</span><span>版权所有 &nbsp; 四川资阳跨界贸易有限服务公司</span>&nbsp;&nbsp;&nbsp;&nbsp; <span>承办单位:四川省外综云服科技有限公司</span></div>
                <div class="info">蜀公网安备 蜀ICP备2021002738号-1</div>
            </div>
            <div class="bottom-right">
                <div class="img-box">
                    <img src="../assets/images/qrcode.jpg" alt="" width="98px" height="98px">
                    <div class="text-qrcode">关注外综云服</div>
                </div>

            </div>
        </div>

    </div>
</div>
</template>

<script>
import navTop from '@/components/navTop'
import {ossUrl} from "@/utils/config"
export default {
    name: "newsDetails",
    components: {
        navTop
    },
    data() {
        return {
            image:ossUrl+'/bg_5.png',
            btnsList: [{
                id: 0,
                text: "新闻动态",
                isClick: true,
            }, {
                id: 1,
                text: "政策通知",
                isClick: false,
            }],
            year: "2021",
            date: "08.28",
            newsList: [{
                id: 0,
                title: "加强学习领会习近平生态文明思想，持续提升新区生态文明建设水平！",
                year: "2021",
                date: "08.28",
                text: "8月26日下午，四川天府新区党工委副书记、成都科学城党工委书记邱旭东带队前往华阳街道，调研天府新区入河排口情况。邱旭东一行来到南湖东路桥上游130米府河左岸城镇雨洪排口，现场听取了排口日常管…",
                icon: require("../assets/images/cross-icon.png")
            }, {
                id: 1,
                title: "加强学习领会习近平生态文明思想，持续提升新区生态文明建设水平！",
                year: "2021",
                date: "08.28",
                text: "8月26日下午，四川天府新区党工委副书记、成都科学城党工委书记邱旭东带队前往华阳街道，调研天府新区入河排口情况。邱旭东一行来到南湖东路桥上游130米府河左岸城镇雨洪排口，现场听取了排口日常管…",
                icon: require("../assets/images/cross-icon.png")
            }, {
                id: 3,
                title: "加强学习领会习近平生态文明思想，持续提升新区生态文明建设水平！",
                year: "2021",
                date: "08.28",
                text: "8月26日下午，四川天府新区党工委副书记、成都科学城党工委书记邱旭东带队前往华阳街道，调研天府新区入河排口情况。邱旭东一行来到南湖东路桥上游130米府河左岸城镇雨洪排口，现场听取了排口日常管…",
                icon: require("../assets/images/cross-icon.png")
            }, {
                id: 4,
                title: "加强学习领会习近平生态文明思想，持续提升新区生态文明建设水平！",
                year: "2021",
                date: "08.28",
                text: "8月26日下午，四川天府新区党工委副书记、成都科学城党工委书记邱旭东带队前往华阳街道，调研天府新区入河排口情况。邱旭东一行来到南湖东路桥上游130米府河左岸城镇雨洪排口，现场听取了排口日常管…",
                icon: require("../assets/images/cross-icon.png")
            }]
        }
    },
    methods: {
        returnPage() {
            this.$router.push("/newsList")
        }
    }
}
</script>

<style lang="less" scoped>
.mgt10 {
    margin-top: 10px;
}

.return-text {
    margin-top: 31px;
    padding-bottom: 120px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 22px;
}

.year {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #000000;
    line-height: 20px;
}

.date {
    font-size: 36px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #000000;
    line-height: 50px;
}

.input-box {
    width: 20px;
    padding: 0 5px;
    text-align: center;
}

.newsList {
    width: 100%;
    height: 100%;

    .top-box {
        height: 800px;
        display: flex;
        flex-direction: column;
        background-color: #06162F;

        //border:1px red solid;
        .bg {
            width: 100%;
            height: 100%;
            //border:1px red solid;
            background-position: center center;
            background-size: cover;
            background-repeat: no-repeat;
        }

        .banner-box {
            display: flex;
            //width: 100%;
            flex: 1;
            //border:1px red solid;
            padding-left: 240px;
            padding-top: 300px;
            font-size: 60px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #FFFFFF;
            line-height: 84px;
        }

    }

    .btns-list {
        height: 50px;
        background-color: #0650C5;
        padding-left: 240px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding-top: 15px;
        padding-bottom: 15px;

        .btns-child {
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            //border:1px red solid;
            margin-right: 80px;
            font-size: 16px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: rgba(255, 255, 255, 0.5);
            line-height: 22px;
        }
    }

    .newsDetails-box {
        width: 100%;
        display: flex;
        justify-content: center;
        //padding: 0px 240px;
        padding-top: 80px;
        padding-bottom: 150px;
        //border: 1px red solid;

        .newsDetails-content {
            width: 1440px;
            display: flex;
            justify-content: space-between;
            align-items: flex-start;

            .left-date {
                width: 20%;
                height: 200px;
                display: flex;
                justify-content: center;
                align-items: flex-end;
                flex-direction: column;
                //border: 1px red solid;
            }

            .center-main {
                width: 50%;
                //height: 100%;

                .content {
                    width: 100%;
                    height: 100%;
                    border-bottom: 3px #6A6A6C solid;
                    padding-bottom: 120px;

                    .text {
                        font-size: 16px;
                        font-family: PingFangSC-Light, PingFang SC;
                        font-weight: 300;
                        color: #333333;
                        line-height: 28px;
                        text-indent: 32px;
                    }

                    .center-title-box {
                        width: 100%;
                        //height: 250px;
                        margin-bottom: 50px;
                        border-top: 3px #6A6A6C solid;
                        border-bottom: 3px #6A6A6C solid;

                        .title {
                            font-size: 30px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #333333;
                            line-height: 42px;
                            padding-top: 30px;
                        }

                        .info {
                            font-size: 14px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #333333;
                            line-height: 20px;
                            margin-top: 40px;
                            padding-bottom: 15px;
                        }
                    }
                }

            }

            .right-list {
                width: 20%;
                height: 100%;
                //border: 1px red solid;

                .imgs {
                    width: 100%;
                    position: relative;

                    .show-text {
                        text-align: justify;
                        padding: 15px 30px;
                        //width: 100%;
                        position: absolute;
                        bottom: 0px;
                        left: 0px;
                        font-size: 16px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #FFFFFF;
                        line-height: 22px;
                    }
                }

                .top-title {
                    height: 18px;
                    padding-left: 10px;
                    border-left: 2px #CC1F37 solid;
                    margin-bottom: 18px;
                }

                .list-right-box {
                    background: #F5F5F6;
                    //height: 300px;
                    width: 100%;

                    .list-right-child {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        padding-left: 20px;
                        padding-right: 20px;
                        padding-top: 15px;
                        padding-bottom: 15px;

                        .child-right-text {
                            margin-left: 30px;
                        }
                    }
                }
            }

        }

        //border:1px red solid;

    }

    .footer-box {
        width: 100%;
        //height: 300px;
        //border: 1px red solid;

        .footer-top {
            //width: 100%;
            padding: 0 360px;
            height: 88px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            color: white;
            background-color: #021233;
            border-bottom: 1px rgba(255, 255, 255, 0.1) solid;

            .child-info {
                font-size: 13px;
                font-family: SourceHanSansCN-Regular, SourceHanSansCN;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 16px;
            }
        }

        .footer-bottom {
            //width: 100%;
            height: 188px;
            padding: 0 360px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .bottom-left {
                width: 80%;
                display: flex;
                justify-content: center;
                align-items: flex-start;
                flex-direction: column;
                height: 100%;

                .com,
                .addr,
                .info {
                    margin-bottom: 30px;
                    font-size: 14px;
                    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
                    font-weight: 500;
                    color: #FFFFFF;
                    line-height: 21px;
                }
            }

            .bottom-right {
                width: 20%;
                height: 100%;
                display: flex;
                justify-content: flex-end;
                align-items: flex-start;
                text-align: center;

                .img-box {
                    width: 100px;
                    display: flex;
                    justify-content: center;
                    align-items: flex-start;
                    padding-top: 30px;
                    flex-direction: column;
                    text-align: center;
                    //border: 1px red solid;

                    .text-qrcode {
                        width: 100%;
                        font-size: 14px;
                        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
                        font-weight: 400;
                        color: #FFFFFF;
                        line-height: 21px;
                    }
                }

            }

            background-color: #021233;
        }
    }
}

.active-btn {
    color: white !important;
}

.mgt50 {
    margin-top: 50px;
}
</style>



// WEBPACK FOOTER //
// src/views/newsDetails.vue